(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/services/order-tickets.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/services/order-tickets.js');
"use strict";

const _svs$tur$pay = svs.tur.pay,
  accountServices = _svs$tur$pay.account_services,
  dialogs = _svs$tur$pay.dialogs;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.utils,
  getLatestAccountBalance = _svs$ticketsOrderHome.getLatestAccountBalance,
  getAccountBalanceParams = _svs$ticketsOrderHome.getAccountBalanceParams,
  getConfirmPaymentOptions = _svs$ticketsOrderHome.getConfirmPaymentOptions;
function ticketsPriceSum(tickets) {
  return tickets.reduce((sum, _ref) => {
    let price = _ref.price,
      count = _ref.count;
    return sum + price * count;
  }, 0);
}
const createMailBoxPlayerOrderRequest = ticketsToOrder => ({
  referenceId: svs.utils.svsuid(),
  orderItems: ticketsToOrder.map(function () {
    let ticket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      productCode: parseInt(ticket.id, 10),
      quantity: ticket.count
    };
  })
});
const orderTicketsHome = async _ref2 => {
  let next = _ref2.next,
    tickets = _ref2.tickets;
  svs.ui.loader.show();
  try {
    const request = createMailBoxPlayerOrderRequest(tickets);
    const _await$svs$tur$apiCal = await svs.tur.apiCaller.ticketgames.postMailboxPlayerOrder({
        data: request
      }),
      response = _await$svs$tur$apiCal.response;
    next({
      response
    });
  } catch (e) {
    svs.tur.pay.logger.error("Ordered ".concat(tickets.map(_ref3 => {
      let id = _ref3.id,
        name = _ref3.name,
        count = _ref3.count;
      return "".concat(count, " st ").concat(name, "(").concat(id, ")");
    }).join(','), " failed: ").concat(e));
    next({
      error: e
    });
  }
  svs.ui.loader.hide();
};
function handleOrderTicketsResult(_ref4) {
  let next = _ref4.next,
    error = _ref4.error;
  if (error) {
    svs.ticketsOrderHome.utils.showErrorMessage(error, next);
    throw error;
  } else {
    next();
  }
}
const orderTickets = _ref5 => {
  let afterPay = _ref5.afterPay,
    tickets = _ref5.tickets,
    onCancel = _ref5.onCancel,
    onDone = _ref5.onDone;
  if (!(tickets !== null && tickets !== void 0 && tickets.length)) {
    return;
  }
  const priceSum = ticketsPriceSum(tickets) + svs.ticketsOrderHome.utils.constants.SHIPPING_COST;
  const price = svs.utils.format.CurrencyFromJupiterString(priceSum);
  const numberOfTickets = tickets.reduce((sum, _ref6) => {
    let count = _ref6.count;
    return sum + count;
  }, 0);
  const isPayAfterDepositEnabled = svs.core.detect.feature('ft-tickets-pay-after-deposit');
  const shouldResolveAfterPay = isPayAfterDepositEnabled && afterPay;
  let accountBalance;
  let response;
  let error;
  let latestAccountBalance;
  const calls = [{
    fn: accountServices.playerSuspension
  }, {
    in: () => ({
      spelpausFlags: [accountServices.playerSpelpaus.CONSTANTS.ALL, accountServices.playerSpelpaus.CONSTANTS.QUICK_GAMES]
    }),
    fn: accountServices.playerSpelpaus
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    in: () => getAccountBalanceParams({
      isPayAfterDepositEnabled,
      price
    }),
    fn: accountServices.accountBalance,
    out: args => {
      var _args = args;
      accountBalance = _args.accountBalance;
      return _args;
    }
  }, {
    fn: accountServices.playerDepositLimits
  }, {
    in: () => getConfirmPaymentOptions({
      price,
      accountBalance
    }),
    fn: shouldResolveAfterPay ? _ref7 => {
      let next = _ref7.next;
      return next();
    } : dialogs.confirmPayment
  }, {
    in: () => ({
      tickets
    }),
    fn: orderTicketsHome,
    out: args => {
      var _args2 = args;
      response = _args2.response;
      error = _args2.error;
      return _args2;
    }
  }, {
    in: () => ({
      response,
      error
    }),
    fn: handleOrderTicketsResult
  }, {
    fn: getLatestAccountBalance,
    out: args => {
      var _args3 = args;
      latestAccountBalance = _args3.latestAccountBalance;
      return _args3;
    }
  }, {
    in: () => ({
      price,
      numberOfTickets,
      accountBalance: latestAccountBalance !== null && latestAccountBalance !== void 0 ? latestAccountBalance : accountBalance
    }),
    fn: shouldResolveAfterPay ? svs.ticketsOrderHome.components.afterPaymentDialog : _ref8 => {
      let next = _ref8.next;
      return next();
    }
  }];
  const cancel = () => {
    onCancel === null || onCancel === void 0 || onCancel();
  };
  const done = () => {
    onDone === null || onDone === void 0 || onDone({
      response,
      error
    });
  };
  svs.tur.pay.initPay({
    calls,
    cancel,
    done,
    shouldDisplayGeneralError: false
  });
};
setGlobal('svs.ticketsOrderHome.services.orderTickets', orderTickets);

 })(window);